import {
    INSERT_STATES_WAGES,
    GET_STATES_WAGES,
    INSERT_STATES_WAGES_ERR,
    GET_STATES_WAGES_ERR,
    INSERT_NEW_HIRES,
    GET_NEW_HIRES,
    INSERT_NEW_HIRES_ERR,
    GET_NEW_HIRES_ERR,
    GET_STATES_WAGES_FOR_EXPORT,
    GET_STATES_WAGES_FOR_EXPORT_ERR,
    GET_NEW_HIRES_FOR_EXPORT,
    GET_NEW_HIRES_FOR_EXPORT_ERR,
    GET_WC_STATES,
    GET_WC_STATES_ERR,
    INSERT_WC_STATES,
    INSERT_WC_STATES_ERR,
    GET_WC_STATES_FOR_EXPORT,
    GET_WC_STATES_FOR_EXPORT_ERR,
  } from "constants/ActionTypes";

var initialState = {
    loader: new Date(),
    statesWages: [],
    newHires: [],
    wcStates: [],
    statesWagesStatus: "not done",
    insertStatesWagesStatus: "not done",
    insertNewHiresStatus: "not done",
    getStatesWagesStatus: "not done",
    getNewHiresStatus: "not done",
    getExportStatesWagesStatus: 'not done',
    getExportNewHiresStatus: 'not done',
    getWcStatesStatus: "not done",
    insertWcStatesStatus: "not done",
    getExportWcStatesStatus: "not done",
};

export default function(state = initialState, action) {
    switch (action.type) {
        case INSERT_STATES_WAGES:
            return {
                ...state,
                loader: new Date(),
                statesWages: action.payload,
                insertStatesWagesStatus: "done",
                getExportStatesWagesStatus: 'not done',
                getStatesWagesStatus: "not done",
            };
        case GET_STATES_WAGES:
            console.log("Get Wages Reducer: ", action.payload);
            return {
                ...state,
                loader: new Date(),
                statesWages: action.payload,
                getStatesWagesStatus: "done",
                insertNewHiresStatus: "not done",
                getExportStatesWagesStatus: 'not done'
            };
        case INSERT_NEW_HIRES:
            return {
                ...state,
                loader: new Date(),
                newHires: action.payload,
                insertNewHiresStatus: "done",
            };
        case GET_NEW_HIRES:
            console.log("Get Wages Reducer: ", action.payload);
            return {
                ...state,
                loader: new Date(),
                newHires: action.payload,
                getNewHiresStatus: "done",
            };
        case INSERT_STATES_WAGES_ERR:
            return {
                ...state,
                loader: new Date(),
                insertStatesWagesStatus: "error",
                getExportStatesWagesStatus: 'not done',
                getStatesWagesStatus: "not done",
            };
        case GET_STATES_WAGES_ERR:
            return {
                ...state,
                loader: new Date(),
                getStatesWagesStatus: "error",
                getExportStatesWagesStatus: 'not done',
                insertNewHiresStatus: "not done",
            };
        case INSERT_NEW_HIRES_ERR:
            return {
                ...state,
                loader: new Date(),
                insertNewHiresStatus: "error"
            };
        case GET_NEW_HIRES_ERR:
            return {
                ...state,
                loader: new Date(),
                getNewHiresStatus: "error"
            };
        case GET_STATES_WAGES_FOR_EXPORT:
            return {
                ...state,
                loader: new Date(),
                statesWages: action.payload,
                getExportStatesWagesStatus: "done",
                getStatesWagesStatus: "not done",
            };
        case GET_STATES_WAGES_FOR_EXPORT_ERR:
            return {
                ...state,
                loader: new Date(),
                getExportStatesWagesStatus: "error",
                getStatesWagesStatus: "not done",
            };
            case GET_NEW_HIRES_FOR_EXPORT:
                return {
                    ...state,
                    loader: new Date(),
                    newHires: action.payload,
                    getExportNewHiresStatus: "done",
                    getNewHiresStatus: "not done",
                };
            case GET_NEW_HIRES_FOR_EXPORT_ERR:
                return {
                    ...state,
                    loader: new Date(),
                    getExportNewHiresStatus: "error",
                    getNewHiresStatus: "not done",
                };
            case INSERT_WC_STATES:
                return {
                    ...state,
                    loader: new Date(),
                    wcStates: action.payload,
                    insertWcStatesStatus: "done",
                    getExportWcStatesStatus: "not done",
                    getWcStatesStatus: "not done",
                };
            case INSERT_WC_STATES_ERR:
                return {
                    ...state,
                    loader: new Date(),
                    insertWcStatesStatus: "error",
                    getExportWcStatesStatus: "not done",
                    getWcStatesStatus: "not done",
                };
            case GET_WC_STATES:
                console.log("Get Wages Reducer: ", action.payload);
                return {
                    ...state,
                    loader: new Date(),
                    wcStates: action.payload,
                    getWcStatesStatus: "done",
                    insertWcStatesStatus: "not done",
                    getExportWcStatesStatus: "not done",
                };
            case GET_WC_STATES_ERR:
                return {
                    ...state,
                    loader: new Date(),
                    getWcStatesStatus: "error",
                    insertWcStatesStatus: "not done",
                    getExportWcStatesStatus: "not done",
                };
            case GET_WC_STATES_FOR_EXPORT:
                return {
                    ...state,
                    loader: new Date(),
                    newHires: action.payload,
                    getExportWcStatesStatus: "done",
                    getWcStatesStatus: "not done",
                    insertWcStatesStatus: "not done",
                };
            case GET_WC_STATES_FOR_EXPORT_ERR:
                return {
                    ...state,
                    loader: new Date(),
                    getExportWcStatesStatus: "error",
                    getWcStatesStatus: "not done",
                    insertWcStatesStatus: "not done",
                };
        default:
            return state;
    }
}